export const SET_DATE = "TELEMATICS_MACHINES/SET_DATE";
export const FETCH_AGGREGATED_MACHINES =
  "TELEMATICS_MACHINES/SAGA/FETCH_AGGREGATED_MACHINES";
export const SET_OPENED_MACHINE_ROWS =
  "TELEMATICS_MACHINES/SET_OPENED_MACHINE_ROWS";
